import { useCallback, useState } from 'react';

import { timeoutFetchSentryGuard } from 'Fetch';
import { getValuationStatus } from 'PrivateApis';

import { isOfferRestrictedToModify } from 'Utilities/restricted';

import { Slug } from '../../profiling/@types';

type GetEnquiryStatusProps = {
  dpStateSlug?: Slug | null;
}

const useGetEnquiryStatus = ({ dpStateSlug }: GetEnquiryStatusProps = {}) => {
  const [data, setData] = useState<Slug | null | undefined>(dpStateSlug);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetched, setIsFetched] = useState<boolean>(false);

  const getEnquiryStatus = useCallback(async (dpEnquiryId: number) => {
    setIsLoading(true);

    const response = await getValuationStatus(dpEnquiryId)
      .catch((err: any) => {
        timeoutFetchSentryGuard(err, () => {
          window.Sentry?.captureException?.(new Error(err), {
            extra: {
              dpEnquiryId,
            },
            tags: {
              fetch: 'Get an enquiry\'s status',
            },
          });
        });
      });

    const slug = response?.state?.slug;

    setData(slug);
    setIsLoading(false);
    setIsFetched(true);

    return slug;
  }, []);

  return {
    data,
    getEnquiryStatus,
    isFetched,
    isLoading,
    isOfferRestricted: isOfferRestrictedToModify(data),
    isSuccess: !!data,
  };
};

export default useGetEnquiryStatus;
